<template>
  <thead :style="`position: sticky; top: ${top}px; z-index: 1`">
    <slot name="ontop" :headers="headers"/>
    <tr>
      <th v-for="(header, idx) in headers" :key="idx" :style="`text-align: ${header.align || 'left'}`">
        <slot :name="`header:${header.value}`" :header="header" :idx="idx">
          {{header.text}}
        </slot>
      </th>
    </tr>
    <slot name="onbottom" :headers="headers"/>
  </thead>
</template>

<script>
import loader_mixin from './loader_mixin'
export default {
  mixins: [loader_mixin],
  props: {
    top: {
      type: Number,
      default: 0
    }
  },
  mounted(){
    this.$nextTick(()=> console.log(this))
  }
}
</script>